import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { UserImportService } from './user-import.service';

@Injectable({
    providedIn: 'root',
})
export class UserImportServiceImpl implements UserImportService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    importUsers(file: File, org: string): Observable<any> {
        const formData = new FormData();
        const blob = new Blob([file], { type: 'text/csv;charset=utf-8;' });
        formData.append('file', blob, 'file');
        return this.store.select(environmentSelector).pipe(
            switchMap((env) =>
                this.http
                    .post(`${env.baseUrl}/cerberus/importusers`, formData, {
                        headers: { 'x-organisation': org, 'Accept-Language': 'fr' },
                    })
                    .pipe(map((res) => res)),
            ),
        );
    }
}

export const USER_IMPORT_SERVICE_PROVIDER = {
    provide: UserImportService,
    useClass: UserImportServiceImpl,
};
